import { Box, Container } from '@mui/material';
import { QuickActions } from './QuickActions';
import { HomeMessagesSummary } from './HomeMessagesSummary';
import { HomeAlertsSummary } from './HomeAlertsSummary';
import { LatestPublishedOffers } from './LatestPublishedOffers';
import { MyRecentPurchases } from './MyRecentPurchases';
import { MyRecentPublications } from './MyRecentPublications';

export function HomePage() {
  return (
    <Box sx={{ px: 3, pb: 3, pt: 1 }}>
      <Box sx={{ mt: 0 }}>
        <Container maxWidth="md" sx={{ px: 0, pt: 0 }}>
          <QuickActions />
          <HomeMessagesSummary />
          <Box sx={{ mt: 1 }}>
            <HomeAlertsSummary />
          </Box>
          <Box sx={{ mt: 3 }}>
            <LatestPublishedOffers />
          </Box>
        </Container>
      </Box>
      <Box sx={{ mt: 3 }}>
        <Container maxWidth="md" sx={{ px: 0, pt: 0 }}>
          <MyRecentPurchases />
        </Container>
      </Box>
      <Box sx={{ mt: 3 }}>
        <Container maxWidth="md" sx={{ px: 0, pb: 10, pt: 0 }}>
          <MyRecentPublications />
        </Container>
      </Box>
    </Box>
  );
}
